
/* eslint-disable sort-keys */
export const ssoWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
}

export const ssoContent = {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    variants: {
        lightBot: {
            true: {
                flexDirection: 'row',
                borderColor: '$questionnaireLightBotBubbleBorder',
                borderWidth: '$questionnaireLightBotBubble',
                borderStyle: '$questionnaireLightBotBubble',
                borderRadius: '$questionnaireLightBotBubble',
                borderTopLeftRadius: '3px',
                padding: '10px',
            },
        },
    },
}

export const iconWrapper = {
    color: '$questionnaireSsoIcon',
    width: '60px',
    margin: '5px',
    variants: {
        lightBot: {true: {width: '30px'}},
        status: {
            default: {},
            inprogress: {color: '$questionnaireSsoIcon'},
            error: {color: '$questionnaireSsoIconError'},
            success: {color: '$questionnaireSsoIconSuccess'},
        },
    },
}

export const textWrapper = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    h2: {margin: '10px 0 5px'},
    variants: {
        lightBot: {
            true: {
                h2: {
                    fontSize: '16px',
                    margin: '0 0 5px',
                },
                alignItems: 'flex-start',
                marginLeft: '10px',
            },
        },
    },
}

export const text = {
    textAlign: 'center',
    variants: {lightBot: {true: {textAlign: 'left'}}},
}

export const buttonWrapper = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: '20px',
    variants: {
        align: {right: {justifyContent: 'flex-end'}},
        status: {
            default: {},
            inprogress: {},
            error: {},
            success: {},
        },
    },
}
